import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { CATEGORY_INTERNAL_SEPERATOR } from '@components/UI-Components/HierarchyWiseItems/constants'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import HierarchyCell from '@modules/order/components/CellTemplates/components/HierarchyCell/HierarchyCell'
import formatNumberByLocale from '@utils/format-number-by-locale'
import last from 'lodash/last'
import split from 'lodash/split'
import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core'
import useViewContext from '@modules/order/hooks/use-view-context'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { stores } from '@stores'
import { getProductAttributeValue } from '@utils/get-product-attribute-value'

const useStyles = makeStyles(theme => ({
  heirarchyLabel: {
    paddingRight: 5,
    textTransform: 'capitalize'
  }
}))

const EnhancedListHierarchyHeader: FC<CellItem> = ({ rowData, column }) => {
  const classes = useStyles()
  const { uiStore } = useViewContext()
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const {
    productConfiguration: { findSpecificAttribute, defaultValuesFromConfig = {} }
  } = stores
  const {
    getOrderHierarchyKPIs,
    dataStore: { heirarchy }
  } = uiStore as EnhancedListUIStore<any>
  const hierarchy = getOrderHierarchyKPIs(rowData?.name, heirarchy)
  const value = last(split(rowData?.[column?.field] || '', CATEGORY_INTERNAL_SEPERATOR))

  const attributeObj = findSpecificAttribute(rowData?.attributeId)
  let nodeText = getProductAttributeValue(
    { name: value },
    attributeObj,
    true,
    defaultValuesFromConfig
  )

  const isMainHeirarchy = !rowData?.[column?.field]?.includes(CATEGORY_INTERNAL_SEPERATOR)
  const count = hierarchy?.totalProducts || hierarchy?.countOfClientOrderProductId || ''
  return (
    <HierarchyCell>
      <Typography
        variant={isMainHeirarchy ? 'h6' : 'caption'}
        className={classes.heirarchyLabel}
      >
        {`${nodeText}`.toLowerCase()}
      </Typography>
      <Typography variant='captionGrey'>{`${formatNumberByLocale(count)}`}</Typography>
    </HierarchyCell>
  )
}

export default EnhancedListHierarchyHeader
